import { tokenExpiredSync } from "../routes/AuthRoutesProvider";

export const logout = async () => {
  tokenExpiredSync();

  window.location.href = "/login";
  window.location.reload();
};
